import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';



  export const projectDetailSlice = createSlice({
    name: 'projectDetail',
    initialState,
    reducers: {
      setBillsData:(state, action) => {
        state.billsData = action.payload
      },
      deleteBillsRow:(state, action) => {
        state.billsData.splice(state.billsData.findIndex((d) => d.id === action.payload), 1)
      },
      updateBillsData:(state, action) => {
        state.billsData[action.payload.index][action.payload.key] = action.payload.value
      },
      setDevelopmentsData:(state, action) => {
        state.developmentsData = action.payload
      },
      deleteDevelopmentsRow:(state, action) => {
        state.developmentsData.splice(state.developmentsData.findIndex((d) => d.id === action.payload), 1)
      },
      setSlaData:(state, action) => {
        state.slaData = action.payload
      },
      deleteSlaRow:(state, action) => {
        state.slaData.splice(state.slaData.findIndex((d) => d.id === action.payload), 1)
      },
      setMemoData:(state, action) => {
        state.memoData = action.payload
      },
      deleteMemoRow:(state, action) => {
        state.memoData.splice(state.memoData.findIndex((d) => d.id === action.payload), 1)
      },
      setProjectData:(state, action) => {
        state.project = action.payload
      },
      updateProjectData:(state, action) => {
        state.project = {...state.project,[action.payload.name]:action.payload.value}
      },
      setOngoingStatuses:(state, action) => {
        state.ongoingStatuses = action.payload
      },
      setOngoingData:(state, action) => {
        state.ongoingData = action.payload
      },
      updateOngoingData:(state, action) => {
        state.ongoingData[action.payload.name] = action.payload.value
      },
      setInvoiceStatues:(state, action) => {
        state.invoiceStatuses = action.payload
      },
      setCrInvoiceStatuses:(state,action) => {
        state.crInvoiceStatuses = action.payload
      },
      setCrStatuses:(state,action) => {
        state.crStatuses = action.payload
      },
      setSLAInvoiceStatuses:(state,action) => {
        state.slaInvoiceStatuses = action.payload
      },
      setTechnologies:(state,action) => {
        state.technologies = action.payload
      },
      setEdittedRow:(state,action) => {
        state.edittedRow = action.payload
      },
      updateEdittedRow:(state,action) => {
        state.edittedRow[action.payload.key] = action.payload.value;
        if (action.budget) {
          state.edittedRow.budget = action.budget * action.payload.value
        }
      },
      setOutsourceData:(state,action) => {
        state.outsourceData = action.payload
      },
      setOutsourceInvoiceData:(state,action) => {
        state.outsourceInvoiceData = action.payload
      },
      deleteOutsourceRow:(state, action) => {
        state.outsourceData.splice(state.outsourceData.findIndex((d) => d.id === action.payload), 1)
      },
      deleteOutsourceInvoiceRow:(state, action) => {
        state.outsourceInvoiceData.splice(state.outsourceInvoiceData.findIndex((d) => d.id === action.payload), 1)
      },
      setLeasingData:(state, action) => {
        state.leasingData = action.payload
      },
      deleteLeasingRow:(state, action) => {
        state.leasingData.splice(state.leasingData.findIndex((d) => d.id === action.payload), 1)
      },
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })

  export const { setBillsData, deleteBillsRow, setDevelopmentsData, setSlaData, setMemoData, setProjectData, setOngoingData, updateOngoingData, setOngoingStatuses, updateProjectData, setInvoiceStatues, setCrInvoiceStatuses, setCrStatuses, setSLAInvoiceStatuses, deleteDevelopmentsRow, deleteSlaRow, deleteMemoRow ,setTechnologies,updateBillsData, setEdittedRow, updateEdittedRow, setOutsourceData, setOutsourceInvoiceData, deleteOutsourceRow, deleteOutsourceInvoiceRow, setLeasingData, deleteLeasingRow} = projectDetailSlice.actions

  export default projectDetailSlice.reducer
